import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: any, args?: any): any {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  // transform(url) {
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  // }

}



// @Pipe({name: 'safeHtml'})
// export class Safe {
//   constructor(private sanitizer:DomSanitizer){}

//   transform(style) {
//     return this.sanitizer.bypassSecurityTrustHtml(style);
//     //return this.sanitizer.bypassSecurityTrustStyle(style);
//     // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
//   }
// }


